import { BUSINESS_OWNER_TYPE } from '@/entities/user/api/user.api';

/** 전화번호를 010-0000-0000 형식으로 표시 */
export const formatPhoneNumber = (value?: string | null): string => {
  if (!value) return '-';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value;
};

export const formatFeeRate = (value?: number | null): string => {
  if (value == null) return '0%';
  return `${(value * 100).toFixed(2)}%`;
};

/** 가입 일자 등 ISO 시각 표시 */
export { formatDateTime } from '@/shared/lib/dateFormat';

export const getUserRowId = (user: {
  id?: number;
  userId?: number;
}): string => {
  if (user.id != null) return String(user.id);
  if (user.userId != null) return String(user.userId);
  return '-';
};

/**
 * 목록용 사업자 유형 표시.
 * 상세의 `businessOwnerTypeLabel`(미등록)과 달리 스펙은 미지정이다.
 */
export const listBusinessOwnerTypeLabel = (
  type: string | null | undefined,
): string => {
  if (type === BUSINESS_OWNER_TYPE.INDIVIDUAL) return '개인';
  if (type === BUSINESS_OWNER_TYPE.CORPORATE) return '법인';
  return '미지정';
};
